(function () {
	const _form = document.getElementById('newsletter-subscribe-form');
	
	if (!_form) {
		return;
	}
	
	new FormValidator(_form, {
		errorMode: 'alert',
		resetAfterSubmit: true,
		
		onsuccess: (response) => {
			flashMessage.show('info', response);
		},
	});
}());